import { hasInstallPromptSessionBypass, isMobileDevice, isStandaloneDisplay } from '@/presentation/composables/usePwaInstall.composable';

const INSTALL_ROUTE_NAMES = new Set(['InstallApp', 'IosPwaInstallGuide']);

export const shouldRedirectMobileToInstall = (routeName?: string | symbol | null) => {
	if (INSTALL_ROUTE_NAMES.has(String(routeName || ''))) return false;
	return isMobileDevice() && !isStandaloneDisplay() && !hasInstallPromptSessionBypass();
};

const mobileInstallMiddleware = (router) => {
	router.beforeEach((to) => {
		if (!shouldRedirectMobileToInstall(to.name)) return true;

		return {
			name: 'InstallApp',
			query: { redirect: to.fullPath },
			replace: true,
		};
	});
};

export default mobileInstallMiddleware;
